import { CheckoutDirectDebitMethod } from '@checkout';
import {
  ClientBrandCode,
  RequestAction,
  RequestSource,
  TrustBox,
} from '@common';
import { BuildConfig, DomainId } from '@config';

export const buildConfig: BuildConfig = {
  applianceRegistrationLimit: 10,
  appVariantConfigPath: 'gb/sidedoor-amdea',
  buildFeatures: {},
  checkout: {
    directDebit: {
      method: CheckoutDirectDebitMethod.AccountNumberSortCode,
    },
  },
  defaultDomainId: DomainId.Beko,
  domainIdMapping: {
    [DomainId.Baumatic]: /baum(?:atic)*\.[\w.-]*partners/,
    [DomainId.Beko]: /beko\.[\w.-]*partners/,
    [DomainId.Belling]: /bell(?:ing)*\.[\w.-]*partners/,
    [DomainId.Blomberg]: /blomb(?:erg)*\.[\w.-]*partners/,
    [DomainId.Candy]: /candy\.[\w.-]*partners/,
    [DomainId.Cannon]: /cannon\.[\w.-]*partners/,
    [DomainId.Creda]: /creda\.[\w.-]*partners/,
    [DomainId.Flavel]: /flavel\.[\w.-]*partners/,
    [DomainId.Grundig]: /grundig\.[\w.-]*partners/,
    [DomainId.Haier]: /haier\.[\w.-]*partners/,
    [DomainId.Hoover]: /hoover\.[\w.-]*partners/,
    [DomainId.Hotpoint]: /hotp(?:oint)*\.[\w.-]*partners/,
    [DomainId.Indesit]: /indesit\.[\w.-]*partners/,
    [DomainId.LEC]: /lec\.[\w.-]*partners/,
    [DomainId.Leisure]: /leisure\.[\w.-]*partners/,
    [DomainId.LG]: /lg\.[\w.-]*partners/,
    [DomainId.Maytag]: /maytag\.[\w.-]*partners/,
    [DomainId.Stoves]: /stoves\.[\w.-]*partners/,
    [DomainId.Whirlpool]: /whirl(?:pool)*\.[\w.-]*partners/,
    [DomainId.Zenith]: /zenith\.[\w.-]*partners/,
  },
  modelNumberSearchEnabledBrands: [
    ClientBrandCode.Beko,
    ClientBrandCode.Hotpoint,
    ClientBrandCode.Indesit,
    ClientBrandCode.Whirlpool,
  ],
  retailerFieldEnabledBrands: [],
  trustpilot: {
    businessUnitId: '4cb3113600006400050dfb02',
    templates: [
      { id: '5419b6ffb0d04a076446a9af', name: TrustBox.Micro },
      { id: '54ad5defc6454f065c28af8b', name: TrustBox.Slider },
    ],
  },
  requestAction: RequestAction.AmdeaRegistration,
  whiteLabelClient: RequestSource.DomesticAndGeneralUK,
};
